import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
var TransitionStatus;

(function (TransitionStatus) {
  TransitionStatus["ENTERED"] = 'entered';
  TransitionStatus["ENTERING"] = 'entering';
  TransitionStatus["EXITED"] = 'exited';
  TransitionStatus["EXITING"] = 'exiting';
})(TransitionStatus || (TransitionStatus = {}));

function useTransition(transitionIsOpen) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

  var _useState = useState(transitionIsOpen ? TransitionStatus.ENTERED : TransitionStatus.EXITED),
      _useState2 = _slicedToArray(_useState, 2),
      transitionState = _useState2[0],
      setTransitionState = _useState2[1];

  useEffect(function () {
    setTransitionState(function (currentState) {
      if (transitionIsOpen) {
        return currentState !== TransitionStatus.ENTERED ? TransitionStatus.ENTERING : TransitionStatus.ENTERED;
      }

      return currentState !== TransitionStatus.EXITED ? TransitionStatus.EXITING : TransitionStatus.EXITED;
    });
    var timer = setTimeout(function () {
      setTransitionState(function (currentState) {
        switch (currentState) {
          case TransitionStatus.ENTERING:
            return TransitionStatus.ENTERED;

          case TransitionStatus.EXITING:
            return TransitionStatus.EXITED;

          default:
            return currentState;
        }
      });
    }, duration);
    return function () {
      return clearTimeout(timer);
    };
  }, [duration, transitionIsOpen]);
  return transitionState;
}

export { TransitionStatus, useTransition };